var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { T } from 'helpers/i18n';
import { toDate, toMoney } from 'helpers/Format';
import { dateMonthsBefore } from 'helpers/Date';
import { Modal, Table } from 'components';
import { Button, DatePicker } from 'elements';
var Report = /** @class */ (function (_super) {
    __extends(Report, _super);
    function Report() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            from: dateMonthsBefore(new Date(), 1),
            to: new Date(),
            fromVisible: false,
            toVisible: false
        };
        _this.handleOnSelectItem = function (item) {
            var items = _this.props.items;
            var ticket = items.filter(function (value) { return value.id === item.id; });
            if (_this.props.onSelectItem) {
                _this.props.onSelectItem(ticket[0]);
            }
        };
        _this.toggleFromModal = function () {
            return _this.setState({ fromVisible: !_this.state.fromVisible });
        };
        _this.toggleToModal = function () {
            return _this.setState({ toVisible: !_this.state.toVisible });
        };
        _this.handleFromChange = function (_, from) {
            _this.toggleFromModal();
            _this.setState({ from: from });
        };
        _this.handleToChange = function (_, to) {
            _this.toggleToModal();
            _this.setState({ to: to });
        };
        _this.filteredItems = function (items) {
            var _a = _this.state, from = _a.from, to = _a.to;
            // return items
            return items; // .filter(item => item.date < to && item.date > from)
        };
        return _this;
    }
    Report.prototype.render = function () {
        var _a = this.props, header = _a.header, items = _a.items, total = _a.total, format = _a.format, props = __rest(_a, ["header", "items", "total", "format"]);
        var _b = this.state, from = _b.from, to = _b.to, fromVisible = _b.fromVisible, toVisible = _b.toVisible;
        var filterDate = props.filterDate === undefined ? true : props.filterDate;
        var filteredItems = filterDate ? this.filteredItems(items) : items;
        var fomatedItems = format(filteredItems);
        return (React.createElement("div", null,
            props.filterDate && React.createElement(Header, null,
                T('from'),
                ":",
                ' ',
                React.createElement(Button, { onClick: this.toggleFromModal }, toDate(from)),
                T('to'),
                ": ",
                React.createElement(Button, { onClick: this.toggleToModal }, toDate(to))),
            React.createElement(Table, __assign({ onSelectItem: this.handleOnSelectItem }, props, { items: fomatedItems, header: header, search: false })),
            total && (React.createElement(Total, null,
                T('total'),
                " ",
                toMoney(total(filteredItems)))),
            fromVisible && (React.createElement(Modal, { title: T('from') },
                React.createElement(DatePicker, { name: 'from', date: from, onChange: this.handleFromChange }))),
            toVisible && (React.createElement(Modal, { title: T('to') },
                React.createElement(DatePicker, { name: 'to', date: to, onChange: this.handleToChange })))));
    };
    return Report;
}(Component));
export default Report;
var Header = cxs('div')({
    paddingLeft: Theme.size.space[1]
});
var Total = cxs('div')({
    padding: Theme.size.space[1],
    borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    textAlign: 'right'
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/components/Report.tsx
// module id = 160
// module chunks = 0